import { render, staticRenderFns } from "./XpressPayAirtimePurchase.vue?vue&type=template&id=59dbf262&scoped=true"
import script from "./XpressPayAirtimePurchase.vue?vue&type=script&lang=js"
export * from "./XpressPayAirtimePurchase.vue?vue&type=script&lang=js"
import style0 from "./XpressPayAirtimePurchase.vue?vue&type=style&index=0&id=59dbf262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dbf262",
  null
  
)

export default component.exports